import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import { RouterModule } from '@angular/router';
import { NotificationModule } from '../../pages/notification/notification.module';
import { RbacAllowDirctiveModule } from '../../_directives/rbac-allow-dirctive/rbac-allow-dirctive.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ShareModule } from '@iq-central-front-end/share';



@NgModule({
  declarations: [NavbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    NotificationModule,
    RbacAllowDirctiveModule,
    MatFormFieldModule,
    MatSelectModule,
    ShareModule
  ],
  exports: [NavbarComponent]
})
export class NavbarModule { }
